import { Repository } from '@basehub/data/replicache/index'
import { PublicRepo } from '@basehub/data/replicache/mutators/_public-types'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { LabeledTextarea } from '~/sotano-kit/primitives/input'
import { md } from './md'
import { useSyncedValue } from '~/hooks/use-synced-value'

export const READMEOverview__Editor = ({
  repo,
}: {
  repo: Repository | PublicRepo
}) => {
  const rr = useRepoReplicache()
  const teamReplicache = rr.data?.teamQueryData?.replicache

  const { onChange, ref, value } = useSyncedValue<HTMLInputElement>({
    value: repo.readme?.additionalInfo?.overview ?? '',
    setValue: async (newValue) => {
      if (!teamReplicache) return

      const currentAditionalInfo = repo.readme?.additionalInfo ?? {
        techStack: [],
        overview: '',
        useCase: [],
        framework: [],
      }

      await teamReplicache.mutate.updateAdditionalInfoREADME({
        repoSlug: repo.slug,
        repoId: repo.id,
        additionalInfo: {
          ...currentAditionalInfo,
          overview: newValue,
        },
      })
    },
    enabled: !!teamReplicache,
    rateLimitType: 'debounce',
    rateLimitMs: 2_000,
  })

  return (
    <LabeledTextarea
      className="!py-0 mb-5"
      label={
        <div className="flex flex-col gap-y-0.5">
          <p className="text-dark-bright">Overview</p>
          <p className="text-dark-muted text-xs">
            Add more context, if you see it relevant. Markdown supported.
          </p>
        </div>
      }
      blocked={false}
      name="overview"
      inputProps={{
        ref,
        autoComplete: 'off',
        className: 'max-h-96 min-h-32',
        maxLength: 2800,
        value,
        onChange: (e) => {
          onChange(e.target.value)
        },
      }}
    />
  )
}

export const READMEOverview__Visitor = ({ overview }: { overview: string }) => {
  if (!overview) return

  return (
    <div>
      <p className="text-lg font-medium mb-1">Overview</p>
      <p
        className="text-dark-dim leading-normal prose-sm prose-pre:overflow-x-auto prose-pre:no-scrollbar pre-a:underline prose-h1:text-base prose-h2:text-sm prose-h3:text-sm"
        dangerouslySetInnerHTML={{
          __html: md(overview ?? ''),
        }}
      />
    </div>
  )
}
